export const defaultSelectIndex: number = -1;